import { Trans, useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import PatternBackground from '../assets/images/not-found/pattern.png';
import Grid from '@mui/material/Grid';
import NotImg from '../assets/images/not-found/not.png';
import Typography from '@mui/material/Typography';
import React from 'react';

export default function NotFound() {
    const { t } = useTranslation();

    return (
        <Stack
            sx={{
                backgroundImage: `url(${PatternBackground})`,
                '&.MuiStack-root': { marginTop: '0px !important', marginBottom: '-6px !important' },
            }}
            minHeight={600}
        >
            <Stack sx={{ ml: { xs: 3, md: 0 }, mr: { xs: 3, md: 0 } }}>
                <Grid
                    borderRadius={4}
                    alignSelf={'center'}
                    p={3}
                    mt={12}
                    mb={12}
                    sx={{ background: '#FFF' }}
                    minWidth={'300px'}
                    maxWidth={'800px'}
                    container
                >
                    <Grid size={{ md: 6, xs: 12 }} textAlign={'center'}>
                        <img src={NotImg} width={'300px'} alt="not-found" />
                    </Grid>
                    <Grid size={{ md: 6, xs: 12 }} alignContent={'center'}>
                        <Stack>
                            <Typography variant="h3" mt={2} lineHeight={'36px'}>
                                {t('not_found.title')}
                            </Typography>
                            <Typography variant="body3" mt={1} lineHeight={'21px'}>
                                <Trans i18nKey={'not_found.subtitle'} t={t} />
                            </Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </Stack>
        </Stack>
    );
}
